/// <reference path="notificationHubServiceBase.ts" />
module ProcessList {

    export class ProcessNotificationsHubService extends NotificationHubServiceBase {
        static $inject = ["$rootScope", "Hub", "$timeout"];

        constructor($rootScope, Hub, $timeout) {
            var listeners = <NotificationListeners>{
                    'processUpdated': function (processNotification) {
                        console.log("process updated", processNotification);
                        $rootScope.$emit("processNotification", processNotification);
                    },
                    'processCountsUpdated': function (processCountsUpdate) {
                        console.log("updating process counts" + (processCountsUpdate.isFullRefresh ? ", full refresh" : ""));
                        $rootScope.$emit("processNotification.countsUpdated.frends", processCountsUpdate);
                    }
                };
            super($rootScope, Hub, $timeout, "ProcessHub", listeners);
        }
    }

    module.service("ProcessNotificationsHubService", ProcessNotificationsHubService);
}